import $ from 'jquery';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

function initFaqArchive() {
    $('.faq-archive').each(function(){
        let $block = $(this);
        let $cats = $(this).find('.faq-archive__cat');
        let $childCats = $(this).find('.faq-archive__child-cat');
        // Set up click event for navigation buttons
        $(this).find('.faq-archive__nav__sub-btn').on('click', function(e) {
            e.preventDefault();
            let index = $(this).data('tab');
            $cats.hide();
            $block.find(`.faq-archive__cat[data-tab="${index}"]`).show();

            ScrollTrigger.refresh();
            let href = $(this).attr('href');
            $('html, body').animate({ scrollTop: $(href).offset().top - 150}, 250);
        });

        // ScrollTrigger setup
        $childCats.each(function() {
            let $cat = $(this);
            let id = $cat.attr('id');
            ScrollTrigger.create({
                trigger: $cat[0],
                start: 'top center', // Adjust this as needed
                end: 'bottom center',
                onEnter: () => updateActiveLink(id),
                onLeaveBack: () => updateActiveLink(id),
                onLeave: () => clearActiveLink(id),
                onEnterBack: () => updateActiveLink(id)
            });
        });

        function updateActiveLink(id) {
            $block.find('.faq-archive__nav__sub-btn').removeClass('active');
            $block.find(`.faq-archive__nav__sub-btn[href="#${id}"]`).addClass('active');
        }

        function clearActiveLink(id) {
            $block.find(`.faq-archive__nav__sub-btn[href="#${id}"]`).removeClass('active');
        }
    });
}

export { initFaqArchive };
